import SmsVerification from '@/pages/SmsVerification'
import {mapGetters,mapActions} from 'vuex'
import mutation from '@/store/mutation.js'
import store from '@/store/index.js'
import util from '../assets/js/util'
import vueWorker from 'vue-worker'
import {Indicator} from 'mint-ui'
var websocket = '';
var _self = {};
var userId = '';
var db = '';
var audio = null;//录音对象
var player = null;  //播放对象
var path = null;  //保存的音频路径
var base64S = null  //base64加密
var unreadTime = null;
var w;
var worker = null;
var sendObj = {};
export default {

  webSocketConn:function (){
    userId = mutation.state.userinfo.id;
    _self = this;

    /*worker = vueWorker.run(n => n + 10, [2])
      .then(res => console.log("sdjlfhskhj"+res))
      .catch(e => console.log(e))*/

   /* alert("公共方法调用");*/
    if(websocket != '' && 1 == websocket.readyState){
    }else{
      if ('WebSocket' in window) {
        websocket = new WebSocket('wss://www.hainanqz.cn/wss/')
        //websocket = new WebSocket('ws://8.134.212.221:3333')
        //websocket = new WebSocket('ws://localhost:3333')
        _self.initWebSocket()
      } else {
        /*alert('不支持连接websocket')*/
      }
    }

  },
  initWebSocket:function  () {
    // 连接错误
    websocket.onerror = this.setErrorMessage

    // 连接成功
    websocket.onopen = this.setOnopenMessage

    // 收到消息的回调
    websocket.onmessage = this.setOnmessageMessage

    // 连接关闭的回调
    websocket.onclose = this.setOncloseMessage

    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = this.onbeforeunload
  },


  setErrorMessage:function  () {
    /*setTimeout(function () {
      if(1 != _self.websocket.readyState && '' != userId ){
        _self.webSocketConn();
      }
    },60000);*/
    console.log('WebSocket连接发生错误   状态码：' + websocket.readyState)
  },
  setOnopenMessage:function  () {
    /*if(this.websocket.readyState == this.websocket.onopen){*/
    console.log('WebSocket连接成功    状态码：' + websocket.readyState)
    _self.hearCheck();
    let id = mutation.state.userinfo.id;
    var data = {
      "userId":id,
      "type":"REGISTER"
    };
    websocket.send(JSON.stringify(data));
    /*}else{
      alert("Websocket连接没有开启！");
    }*/

  },
  setOnmessageMessage:function  (event) {
    //var _self = this;
    // 根据服务器推送的消息做自己的业务处理
    console.log('服务端返回：' + event.data)
    var result = JSON.parse(event.data);
    var status = result.status;
    if(200 == status){
      var bsType = result.data.type;
      if(bsType == 'REGISTER'){
        _self.hearCheck();
      }else if(bsType == 'UNREADMSG'){

      }else if(bsType == 'SINGLE_SENDING'){
        store.commit('setChatMsg',result.data);
        store.commit('setChatMsgNum',result.data);
      }else if(bsType == 'COUPONFOR'){

      }else if(bsType == 'COUPONUNREAD'){

      }else if(bsType == 'UNONLINE'){

      }else if(bsType == 'NOTEXISTCOUPON'){

      }else if(bsType == 'SINGLE_SENDINGSUCCE'){
        console.log("===================发送消息完成");
        store.commit('setSendSingleMsgUnsucce',Math.random().toString());
      }else{

      }
    }else{
      //alert("测试无网络情况");
    }

  },
  /**
   * 判断不等于空或undefined
   * @param obj
   * @returns {boolean}
   */
  isJsonStr(obj){
    return obj !== null &&
    typeof obj !== 'undefined' &&
    typeof  obj === 'string'
  },
  setOncloseMessage:function  (event) {
      websocket.close();
   /* }*/
    console.log('WebSocket连接关闭    状态码：' + websocket.readyState)
  },
  onbeforeunload:function  () {
    this.closeWebSocket()
  },
  closeWebSocket:function  () {
    /*alert("被调用关闭");*/
  },

  singleSending:function (obj) {
    /*alert("发送单条状态"+websocket.readyState);*/
    if(1 == websocket.readyState  && '' != userId){
      var data = {
        "chatid":obj.chatid,
        "type":obj.sendType,
        "content":obj.content,
        "sendMediaType":obj.sendMediaType,
        "fromUserId":obj.fromUserId,
        "toUserId":obj.toUserId,
        "ofUserType":obj.ofUserType,
        "createTime":obj.createTime,
        "isReaded":obj.isReaded
      }
      sendObj = obj;
      websocket.send(JSON.stringify(data));
    }else{
      this.webSocketConn()
      //this.singleSending(obj);
    }

  },
  sendChatMsg:function (content,fromUserId,toUserId) {
    if(1 == websocket.readyState  && '' != userId){
      var data = {
        "type":"SEND_CHAT_MSG",
        "content":content,
        "fromUserId":fromUserId,
        "toUserId":toUserId,
      }
      websocket.send(JSON.stringify(data));
    }else{
      //this.webSocketConn()
      //this.sendChatMsg(content,fromUserId,toUserId);
    }

  },
  unRead:function (userId) {
    if(1 == websocket.readyState  && '' != userId){
      var data = {
        "type":"UNREADMSG",
        "userId":userId,
      }
      websocket.send(JSON.stringify(data));
      clearTimeout(unreadTime);
    }else{
      //this.webSocketConn()
      //this.unRead(userId)
    }
  },
  /**
   * 暂时未用到
   */
  sendUnReadMsg:function (){
    if(1 == websocket.readyState  && '' != userId){
      var data = {
        "userId":this.id,
        "type":"UNREADMSG"
      }
      websocket.send(JSON.stringify(data));
    }else{
      //this.webSocketConn()
      //this.sendUnReadMsg();
    }

  },
  hearCheck:function(){
    /*if(1 == websocket.readyState  && '' != userId){
      setInterval(function(){
        if(1 == websocket.readyState  && '' != userId) {
          var data = {
            "type": "HEARTBEAT",
            "userId": 1,
          }
          websocket.send(JSON.stringify(data));
        }else{
          _self.webSocketConn()
        }
      }, 60000)
    }*//*else{
      _self.webSocketConn()
    }*/
  },quit:function(){
    if(1 == websocket.readyState  && '' != userId){
        var data = {
          "type":"CLOSE",
          "userId":1,
        }
        websocket.send(JSON.stringify(data));
    }/*else{
      _self.webSocketConn()
    }*/
  }
}



// WEBPACK FOOTER //
// ./src/utils/websocket.js